import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import appReducer from './app.reducer';


declare const module: {
  hot: {
    accept(path: string, callback: () => void): void;
  };
};

const configureStore = (preloadedState: any) => {
  const store = createStore(
    appReducer,
    preloadedState,
    applyMiddleware(thunk)
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./app.reducer', () => {
      const nextRootReducer = require('./app.reducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export default configureStore;
